export interface AboutData {
  hero: {
    title: string;
    subtitle: string;
  };
  origin: {
    title: string;
    paragraphs: string[];
    quote: { text: string; author: string };
  };
  values: Array<{
    icon: string;
    title: string;
    description: string;
  }>;
  mascot: {
    title: string;
    paragraphs: string[];
    imagePlaceholder: string;
  };
  store: {
    title: string;
    address: string;
    schedule: string;
    mapUrl: string;
    paragraphs: string[];
  };
  stats: Array<{
    value: string;
    label: string;
  }>;
  cta: {
    title: string;
    subtitle: string;
  };
  socialLinks: Array<{
    platform: string;
    url: string;
    icon: string;
  }>;
}

export const MOCK_ABOUT: AboutData = {
  hero: {
    title: 'Más que una tienda. Una comunidad.',
    subtitle:
      'Somos Perrón Store: el punto de encuentro para jugadores, coleccionistas y apasionados del TCG en Costa Rica.',
  },
  origin: {
    title: 'Cómo empezó todo',
    paragraphs: [
      'Perrón Store nació de una pasión compartida por los juegos de cartas coleccionables. Lo que comenzó como un hobby entre amigos se convirtió en el destino de referencia para la comunidad TCG costarricense.',
      'Desde nuestro local en Zapote, San José, hemos construido un espacio donde el coleccionista encuentra las cartas que busca, el jugador competitivo arma su deck ideal, y el curioso descubre un mundo nuevo de estrategia y comunidad.',
      'Hoy trabajamos con Pokémon, Magic: The Gathering, Yu-Gi-Oh!, One Piece, Digimon, Dragon Ball y mucho más — siempre con el compromiso de ofrecer producto genuino y una experiencia que va más allá de la transacción.',
    ],
    quote: {
      text: 'No vendemos solo cartas. Vendemos la emoción de abrir un sobre, la adrenalina de un torneo y la alegría de encontrar esa carta que llevabas meses buscando.',
      author: 'Omar, fundador de Perrón Store',
    },
  },
  values: [
    {
      icon: 'users',
      title: 'Comunidad primero',
      description:
        'Cada decisión que tomamos pone a nuestra comunidad de jugadores y coleccionistas en el centro. No somos un catálogo frío — somos parte del juego.',
    },
    {
      icon: 'shield-check',
      title: 'Confianza y transparencia',
      description:
        'Producto genuino, precios claros, envíos rastreables. Sin letra pequeña, sin sorpresas. Tu confianza es nuestro capital más valioso.',
    },
    {
      icon: 'heart',
      title: 'Pasión por el juego',
      description:
        'Jugamos, coleccionamos y vivimos esto cada día. Entendemos lo que buscas porque nosotros también lo buscamos.',
    },
  ],
  mascot: {
    title: 'El alma de Perrón Store',
    paragraphs: [
      'Nuestro corgi con gorra TCG no es solo un logo — es la personalidad de la tienda. Nació como un guiño a la energía y lealtad que define a nuestra comunidad: siempre listo para jugar, siempre contento de verte.',
      'Lo encontrarás en nuestras redes, en los empaques de envío y en cada rincón de la web. Cada pose tiene un mensaje, cada aparición un propósito. Es el hilo que conecta todo lo que hacemos.',
    ],
    imagePlaceholder:
      'Ilustración de mascota — pose storytelling con elementos de la tienda',
  },
  store: {
    title: 'Visítanos en persona',
    address: 'Plaza Del Castillo Local #17, Zapote, San José, Costa Rica',
    schedule: 'Martes a Domingo, 12:00 pm – 7:00 pm',
    mapUrl:
      'https://maps.google.com/?q=Plaza+Del+Castillo+Zapote+San+Jose+Costa+Rica',
    paragraphs: [
      'Nuestra tienda física es donde la comunidad cobra vida. Ven a ver producto en persona, participa en eventos y torneos, o simplemente pasa a saludar al equipo.',
    ],
  },
  stats: [
    { value: '+4,500', label: 'seguidores en Instagram' },
    { value: '+3,960', label: 'likes en Facebook' },
    { value: '+4,000', label: 'pedidos en línea' },
    { value: '+2,000', label: 'usuarios registrados' },
  ],
  cta: {
    title: 'Únete a la comunidad Perrón',
    subtitle:
      'Explora nuestra tienda online, síguenos en redes o ven a conocernos en persona.',
  },
  socialLinks: [
    {
      platform: 'Instagram',
      url: 'https://www.instagram.com/perronstorecr/',
      icon: 'instagram',
    },
    {
      platform: 'Facebook',
      url: 'https://www.facebook.com/profile.php?id=100072122377020',
      icon: 'facebook',
    },
    {
      platform: 'TikTok',
      url: 'https://www.tiktok.com/@perronstorecr',
      icon: 'music-2',
    },
  ],
};
